<template>
  <div class="nx-date-picker">
    <div class="nx-date-picker_trigger" @click="showPicker = true">
      <slot
        v-if="$scopedSlots.trigger"
        name="trigger"
        :title="title"
        :value="value"
      />
      <van-field
        v-else
        readonly
        clickable
        name="datetimePicker"
        :value="showValue"
        right-icon="arrow"
        :label="title"
        :placeholder="placeholder"
        input-align="right"
        v-bind="$attrs"
      />
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        :type="type"
        :title="popupTitle || title"
        :formatter="formatter"
        v-bind="$attrs"
        @confirm="handleConfirm"
        @cancel="showPicker = false"
      />
    </van-popup>
  </div>
</template>

<script>
import { formatDate } from '@/utils';
import dayjs from 'dayjs';

/**
 * 时间选择器，支持插槽，示例：src/views/maintenance/appointment/index.vue
 */
export default {
  name: 'NxDatetimePicker',
  props: {
    type: {
      type: String,
      default: 'datetime',
    },
    title: {
      type: String,
      default: '选择时间',
    },
    popupTitle: {
      type: String,
    },
    value: {
      type: [String, Number],
      required: true,
    },
    format: {
      type: String,
      default: 'YYYY-MM-DD HH:mm:ss',
    },
    valueFormat: {
      type: String,
      default: '',
    },
    placeholder: {
      type: String,
      default: '点击选择时间',
    },
    formatter: {
      type: Function,
      default: (type, val) => {
        const map = {
          year: '年',
          month: '月',
          day: '日',
          hour: '时',
          minute: '分',
        };
        if (map[type]) {
          return val + map[type];
        }
        return val;
      },
    },
    // 额外信息返回，无实际操作
    info: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      showPicker: false,
    };
  },
  computed: {
    value_: {
      get() {
        return this.value ? dayjs(this.value).valueOf() : '';
      },
      set(newVal) {
        if (this.valueFormat) {
          return this.$emit('input', formatDate(newVal, this.valueFormat), this.info);
        }
        this.$emit('input', dayjs(newVal).valueOf(), this.info);
        this.$emit('change', dayjs(newVal).valueOf(), this.info);
      },
    },
    showValue() {
      return formatDate(this.value_, this.format);
    },
  },
  methods: {
    handleConfirm(time) {
      this.value_ = time;
      this.showPicker = false;
    },
  },
};
</script>

<style scoped lang="scss">

</style>
